import { Components, Theme } from "@mui/material";
import { ExpandMoreRounded } from "@mui/icons-material";

export default function Select(theme: Theme): Components["MuiSelect"] {
  return {
    defaultProps: { IconComponent: ExpandMoreRounded },
  };
}
